import React, { useCallback, useEffect, useState } from 'react'
import { CircularProgress, Grid, Typography } from '@material-ui/core'
import { useInformacaoService } from 'hooks/useInformacaoService'
import useStyles from './styles'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { ExibirArquivo } from 'components/ExibirArquivo'
import { useSelector } from 'react-redux'

export const ListaInformacoes = (props) => {
  const classes = useStyles()
  const { tipo, id } = props
  moment.locale('pt-br', localization)
  const idsState = useSelector((state) => state.idsState)
  const informacaoService = useInformacaoService()
  const [informacoes, setInformacoes] = useState([])
  const [processandoInformacoes, setProcessandoInformacoes] = useState(false)

  const fetchInformacoesDeEntidade = useCallback(async () => {
    if (id) {
      const response = await informacaoService.listarInformacoesDeEntidade(id, tipo, setProcessandoInformacoes)

      setInformacoes(response)
    }
  }, [tipo, id])

  useEffect(() => {
    fetchInformacoesDeEntidade()
  }, [fetchInformacoesDeEntidade])

  return (
    <div>
      {processandoInformacoes ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid container className={classes.informacoes}>
          {informacoes?.length ? (
            informacoes.map((informacao, index) => (
              <Grid key={index} item container className={classes.divInformacao} spacing={2} style={{ borderBottom: index === informacoes.length - 1 ? '' : 'thin solid #DDD' }}>
                <Grid item md={6} sm={6} xs={12}>
                  <Typography variant="h6">
                    <b>Data do cadastro da informação</b>
                  </Typography>
                  <Typography>{moment(informacao.createdAt).format('LLLL')}</Typography>
                </Grid>
                <Grid item md={6} sm={6} xs={12}>
                  <Typography variant="h6">
                    <b>Usuário que cadastrou a informação</b>
                  </Typography>
                  <Typography>{informacao.usuario ? `${informacao.usuario.nome?.toUpperCase()} - ${informacao.usuario.matricula || 'sem matrícula'}` : ' - '}</Typography>
                </Grid>
                <Grid item md={12} sm={12} xs={12}>
                  <Typography variant="h6">
                    <b>Informação</b>
                  </Typography>
                  <Typography>{informacao.descricao}</Typography>
                </Grid>

                <Grid className={classes.item} item md={12} sm={12} xs={12}>
                  <Typography>
                    <b>Documentos relacionados a esta informação</b>
                  </Typography>
                  {informacao.arqs?.length ? (
                    <Grid container justifyContent="flex-start" alignItems="center">
                      {informacao.arqs.map((arquivo) => (
                        <Grid key={arquivo.id} className={classes.item} item md={2} sm={4} xs={7}>
                          <ExibirArquivo id={arquivo.id} arquivo={arquivo} rotaLoadFile="/arquivo/informacao" />
                        </Grid>
                      ))}
                    </Grid>
                  ) : (
                    <Grid container>
                      <Typography>Nenhum arquivo relacionado a esta informação</Typography>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            ))
          ) : (
            <Grid container className={classes.fieldGroup} justifyContent="center" alignItems="center" style={{ padding: '50px' }}>
              <Typography variant="body2" color="textSecondary">Nenhuma informação adicionada</Typography>
            </Grid>
          )}
        </Grid>
      )}
    </div>
  )
}
